import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getFrontEndVideos } from "../../reducers/commonReducer";

export default function Reals({ catid }) {
  const dispatch = useDispatch();
  const videoRefs = useRef([]);
  useEffect(() => {
    dispatch(getFrontEndVideos({ category: catid }));
  }, []);

  const { getFrontEndVideoList } = useSelector((state) => state.commonReducer);
  const handlePlay = (currentIndex) => {
    videoRefs.current.forEach((video, index) => {
      if (video && index !== currentIndex) {
        video.pause(); // Pause other videos
        video.currentTime = 0; // Optional: Reset to beginning
      }
    });
  };
  return (
    getFrontEndVideoList?.length > 0 && (
      <Container fluid className="p-0 reels-main">
        <div className="py-2 reel-title">
        <h3 className="mb-0 text-black text-center"><i className="bi bi-heart-fill text-red"></i> Happy Customers <i className="bi bi-heart-fill text-red"></i></h3>
        </div>
        <div className="reels-scroll-container">
          {/* {getFrontEndVideoList.map((data, idx) => (
          <div className="reel-video" key={idx}>
            <iframe
              src={data?.video}
              title={data?.title}
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        ))} */}
          {getFrontEndVideoList.map((data, idx) => (
            <div className="reel-video" key={idx}>
              <video
                ref={(el) => (videoRefs.current[idx] = el)}
                src={data?.video}
                controls
                controlsList="nodownload"
                disablePictureInPicture
                onPlay={() => handlePlay(idx)}
              />
            </div>
          ))}
        </div>
      </Container>
    )
  );
}
